/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _omit from 'lodash/fp/omit';
import TileWMSSource from 'ol/source/tilewms';
import { WMS_VERSION, assert, tileSource } from '../core';

var props = {
  extParams: Object, // Additional WMS Request params
  gutter: Number,
  hidpi: Boolean,
  layers: {
    type: String,
    required: true
  },
  serverType: String,
  styles: String, // WMS Request styles
  version: {
    type: String,
    default: WMS_VERSION
  },
  url: {
    type: String,
    required: true
  }
};

var upperCase = function upperCase(x) {
  return x.toUpperCase();
};
var keysToUpperCase = function keysToUpperCase(x) {
  return _Object$keys(x).map(upperCase);
};
var cleanExtParams = function cleanExtParams(params) {
  return _omit(['LAYERS', 'VERSION', 'STYLES'], keysToUpperCase(params));
};

var methods = {
  /**
   * @returns {ol.source.TileWMS}
   * @protected
   */
  createSource: function createSource() {
    return new TileWMSSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      params: _extends({}, cleanExtParams(this.extParams), {
        LAYERS: this.layers,
        STYLES: this.styles,
        VERSION: this.version
      }),
      crossOrigin: this.crossOrigin,
      gutter: this.gutter,
      hidpi: this.hidpi,
      logo: this.logo,
      tileGrid: this._tileGrid,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      serverType: this.serverType,
      wrapX: this.wrapX,
      url: this.urlTmpl
    });
  },

  /**
   * @param {number[]} coordinate
   * @param {number} [resolution]
   * @param {string} [projection]
   * @param {Object} [params] GetFeatureInfo params. `info_format` at least should be provided.
   *                          If `query_layers` is not provided then the layers specified in the `layers` prop will be used.
   *                          `version` should not be specified here (value from `version` prop will be used).
   * @return {string|undefined}
   */
  getFeatureInfoUrl: function getFeatureInfoUrl(coordinate, resolution, projection) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    assert.hasView(this);
    assert.hasSource(this);

    resolution || (resolution = this.$view.getResolution());
    projection || (projection = this.projection);

    return this.$source.getFeatureInfoUrl(coordinate, resolution, projection, cleanExtParams(params));
  }
};

var watch = {
  layers: function layers(LAYERS) {
    this.$source && this.$source.updateParams({ LAYERS: LAYERS });
  },
  version: function version(VERSION) {
    this.$source && this.$source.updateParams({ VERSION: VERSION });
  },
  styles: function styles(STYLES) {
    this.$source && this.$source.updateParams({ STYLES: STYLES });
  },
  extParams: function extParams(value) {
    this.$source && this.$source.updateParams(cleanExtParams(value));
  }
};

var Source = {
  name: 'vl-source-wms',
  mixins: [tileSource],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/wms-source/index.es.js
// module id = null
// module chunks = 